module.exports = __webpack_public_path__ + "img/kunming.2a36dc76.jpg";